import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMoveFolder: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="move-folder"><path d="M12.25 19.25H2.75V3.75H10L12 6.75H21.25V11.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M15.75 17.25H21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M19 14.25L22 17.25L19 20.25" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconMoveFolder;
